import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ── Suppress benign errors from Gaussian Splats library ──────────────────────
// Use capture:true so these handlers run BEFORE the CRA dev overlay (bubble phase).
// Without capture, the overlay registers first and shows the error before our
// preventDefault/stopImmediatePropagation can suppress it.

function _suppressGaussianError(e) {
  const msg = e.message || "";
  const file = e.filename || "";
  if (
    // AbortError when fetch is cancelled on navigation between scene / building
    (msg.includes("Fetch is aborted") || msg.includes("The operation was aborted") || msg.includes("AbortError")) ||
    // DataCloneError from WebWorker postMessage on disposal
    ((msg.includes("postMessage") || msg.includes("DataCloneError") || msg.includes("could not be cloned")) && file.includes("gaussian-splats")) ||
    // ResizeObserver loop — cosmetic, fired by Three.js canvas resize
    msg.includes("ResizeObserver loop")
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
  return false;
}

function _suppressGaussianRejection(e) {
  const r = e.reason;
  const msg = r?.message || String(r || "");
  const name = r?.name || "";
  const code = r instanceof DOMException ? r.code : -1;
  if (
    // AbortError — fetch cancelled on navigation
    name === "AbortError" || code === 20 ||
    msg.includes("Fetch is aborted") || msg.includes("The operation was aborted") ||
    // DataCloneError / postMessage from WebWorker
    msg.includes("postMessage") || msg.includes("DataCloneError") || msg.includes("could not be cloned") ||
    // "Could not load file" from addSplatScene when viewer disposed mid-load
    msg.includes("addSplatScene") || (msg.includes("Could not load") && msg.includes(".splat"))
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
  return false;
}

window.addEventListener("error",             _suppressGaussianError,      { capture: true });
window.addEventListener("unhandledrejection", _suppressGaussianRejection, { capture: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
